(function () {
    // global set
    var areaSites = globalSettings.areaSites;

    var url = window.location.href;
    var pageUrl = url.split('.com')[1];
    if (pageUrl) {
        for (var key in areaSites) {
            areaSites[key] = areaSites[key] + pageUrl;
        }
    }
    if (globalSettings.sitePrefix !== 'en') { return; }
    var fromMap = {
        'AUSTRALIA': 'au',
        'EUROPE': 'eu'
    };
    var from = getUrlParam('from');
    var mobvoiDomain = localStorage.getItem('mobvoi_domain');
    if (from || mobvoiDomain) {
        // save footer area choose
        localStorage.setItem('mobvoi_domain', 'subSite');
    } else {
        // check area
        checkArea();
    }
    function checkArea() {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', '//freegeoip.net/json/', true);
        xhr.onload = function(e) {
            if (this.status === 200 || this.status === 304) {
                var location = JSON.parse(this.responseText);
                var code = location.country_code;
                var time_zone = location.time_zone;
                switch (code) {
                    case 'FR':
                        window.location.href = areaSites.eu;
                        break;
                    case 'DE':
                        window.location.href = areaSites.eu;
                        break;
                    case 'AU':
                        window.location.href = areaSites.au;
                        break;
                    case 'NZ':
                        window.location.href = areaSites.au;
                        break;
                    case 'HK':
                        window.location.href = areaSites.hk;
                        break;
                    case 'IN':
                        var url = window.location.href,
                            urlStrArr = ['ticwatchse', 'product-introduce', 'product-smart-introduce'];
                        var urlSplitArr = url.split('/'),
                            pageName = urlSplitArr[urlSplitArr.length-1];
                        urlStrArr.forEach(function(value){
                            if(pageName === value){
                                window.location.href = 'https://www.amazon.in/Ticwatch-2-Smartwatch-Charcoal/dp/B01NCIGW42/ref=sr_1_1?s=computers&ie=UTF8&qid=1513930928&sr=1-1&keywords=ticwatch';
                            } 
                        });
                        break;
                }
                if (time_zone.indexOf('Europe') > -1) {
                    window.location.href = areaSites.eu;
                }
            }
        };
        xhr.onerror = function(e) { console.log('error') };
        xhr.send('');
    }
    function getUrlParam(name) {
        var reg = new RegExp("(^|&)+" + name + "=([^&]*)(&|$)");
        var r = window.location.search.substr(1).match(reg);
        if (r !== null) {
            return unescape(r[2]);
        } else {
            return "";
        }
    }
})();